import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FreshAuthService } from '../fresh-auth.services';
import { NgbModal, NgbModalRef, } from '@ng-bootstrap/ng-bootstrap';
import { environment as ENV } from '../../../environments/environment';
import { environment } from '../../../environments/environment.ubi'
import { BaseApi } from '../../laas/base-api.service';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { saveAs } from "file-saver/dist/FileSaver";
import FileSaver from "file-saver";
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import { AdminService } from 'app/admin/admin.service';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';

@Component({
  selector: 'wl-view-disbursed',
  templateUrl: './view-disbursed.component.html',
  styleUrls: ['./view-disbursed.component.scss'],
  providers: [AdminService],
})
export class ViewDisbursedComponent implements OnInit {
  selectedDate: any;
  currentDate: String;
  searchHolder: string;
  showSelectedDate: boolean;
  noUserFound: string;
  page: number = 1;
  search = new UntypedFormControl();
  totalCount: any;
  totalPage: number = 1;
  @ViewChild('date1') firstDate: ElementRef;
  allUsers: any = [];
  pageId = 1;
  @ViewChildren('custId') custIds: QueryList<ElementRef>;
  @ViewChild('downloadModal') downloadModal: TemplateRef<any>;
  downloadForms: any[];
  loading: boolean;
  filterTableDate = new Date();
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  downloadDocModalRef: NgbModalRef;
  kccNewUat: string = ENV.kccNewUat;
  limit: number = 10;
  offset: number = 0;
  roleId: string;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showChargeCreation: boolean;
  showDisbursedDataTable: boolean = true;
  filter: string = "";
  wantAccWiseBreDownloaded: boolean;
  applicantId: any;
  @ViewChild('checkRef') checkRef: ElementRef;
  checkbox: any;
  showAccwiseBreCheckBox = false;
  showDownloadDocsModal: boolean;

  constructor(
    private freshAuthService: FreshAuthService,
    private modalService: NgbModal,
    private snackbar: MatSnackBar,
    private baseapi: BaseApi,
    public dialog: MatDialog,
    private https: HttpClient,
    private customer: FreshAuthService,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private advancedFilterService: AdvancedFilterService
  ) {
    this.searchHolder = 'Search Applicant by Name';
  }

  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.pageId = 1;
    this.page = 1;
    this.loading = true;
    this.customer.getLoanDisbursedUsers(value, 1, 0, 10).subscribe(
      (res) => {
        this.loading = false;
        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData || [];
          this.page = 1;
          this.totalCount = res.result.count || 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      (err) => {
        this.totalCount = 0;
        this.totalPage = 0;
        this.loading = false;
        throw err;
      }
    );
  }

  extractChargeDetailsFromJson(user) {
    if (user && user.chargeDetails) {
      let a = user.chargeDetails ? user.chargeDetails : {};
      console.log('a console', a);
      let b;
      let resObj = 'Failed';
      if (a && a != null && a != undefined) {
        console.log('inside a cond');
        b = JSON.parse(a);
        resObj = b.data[0].response.RESPONSE.STATUS[0];
      }
      console.log('resobj', resObj);
      return resObj;
    } else {
      return 'Pending';
    }
  }

  ngOnInit() {
    this.roleId = this.freshAuthService.getRoleId();
    if (this.isCoLogin()) {
      this.showDisbursedDataTable = false;
      this.showAccwiseBreCheckBox = true;
    }

    sessionStorage.removeItem('filterDateDisbursedStart');
    sessionStorage.removeItem('filterDateDisbursedEnd');
    let storeState = sessionStorage.getItem('wEnlw3OeU3');
    if (storeState == 'xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1') {
      console.log('get state');
      this.showChargeCreation = true;
    }
    this.maxDate = this.freshAuthService.getCurrentMonth();
    this.roleId = sessionStorage.getItem('getroleId');
    !this.isCoLogin() && this.getData();

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    // this.checkbox =this.checkRef.nativeElement
  }

  getData() {
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');
    this.freshAuthService
      .loanDisbursed(admin_id, branch_code, ro_code, zonal_code, 0, 10)
      .subscribe(
        (res) => {
          this.loading = false;
          // debugger
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          if (res && res.result && res.result.resultData) {
            let allUsers = res.result.resultData;
            this.allUsers = allUsers.sort(
              (a, b) => Number(new Date(b.loanCreationDate)) - Number(new Date(a.loanCreationDate))
            );
            // this.allUsers =res && res.result && res.result.resultData ?  res.result.resultData :[];
          } else {
            this.allUsers = [];
          }
        },
        (err) => {
          this.loading = false;
          throw err;
        }
      );
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, 'loan_disbursed').subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          let allUsers = res.result.resultData;
          this.allUsers = allUsers.sort(
            (a, b) => Number(new Date(b.loanCreationDate)) - Number(new Date(a.loanCreationDate))
          );
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
          // this.allUsers =res && res.result && res.result.resultData ?  res.result.resultData :[];
        } else {
          this.allUsers = [];
        }
        // this.allUsers = res && res.result && res.result.resultData?res.result.resultData:[];
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;

        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateDisbursedStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateDisbursedEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getLoanDisbursedUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              // let allUsers = res.result.resultData;
              // this.allUsers = allUsers.sort((a,b) =>  Number(new Date(b.loanCreationDate)) - Number(new Date(a.loanCreationDate)));
              // this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              // this.totalPage = Math.ceil(this.totalCount / 10);
              console.log('this.totalPage ' + this.totalPage);
              // this.allUsers =res && res.result && res.result.resultData ?  res.result.resultData :[];
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            } else {
              this.allUsers = [];
            }
          } else if (res && res.result == null) {
            // this.allUsers = this.getEmptyArray()
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  updateCustId(i, value, id) {
    console.log(i, value);
    this.custIds.forEach((val) => console.log(val));
    this.freshAuthService.updateCustId(value, id).subscribe((resp) => {
      console.log(resp);
      if (resp && resp.success) {
        this.snackbar.open('Customer ID updated Successfully', 'OK', { duration: 3000 });
      } else {
        if (resp.message == 'Failure to update as custId not found in CBS') {
          this.openErrorMessageDialog(
            'The entered Customer ID is Not Found in CBS.',
            'Please enter a valid Customer ID.'
          );
        } else if (resp.status == 'F') {
          this.openErrorMessageDialog(
            'Failed to update as custId as ERR005',
            'Customer id has outstanding KCC Loan.'
          );
        } else if (resp.message == 'Failed in Aadhaar No Match') {
          this.openErrorMessageDialog('Failed to update custId as Aadhar number mismatch', '');
        } else {
          this.snackbar.open(`Failed to update ${resp.message}`, 'OK', { duration: 3000 });
        }
      }
    });
  }

  getDocs(user) {
    const applicantId = user.id;
    this.applicantId = user.id;
    this.downloadForms = [];
    this.wantAccWiseBreDownloaded = false;
    this.loading = true;
    this.baseapi.getDocs(user.id).subscribe((resp) => {

      // let resp = {
      //   "success": true,
      //   "result": [
      //       {
      //           "label": "Digitally Signed Document",
      //           "link": "esign/1706870206058"
      //       },
      //       {
      //           "label": "CIC Report",
      //           "link": "esign/1706870206171.pdf"
      //       },
      //       {
      //           "label": "Sanction Letter",
      //           "link": "esign/1706870206302"
      //       },
      //       {
      //           "label": "Loan Application Form",
      //           "link": "esign/1706870206313"
      //       },
      //       {
      //           "label": "Digital Process Note",
      //           "link": "esign/1706870206329"
      //       }
      //   ],
      //   "error": null
      // }

      this.loading = false;
      if (resp.result && resp.result.length) {

        this.downloadForms = resp.result.filter((form) => form.label != 'dm');
        this.downloadForms.forEach((form) => (form.isChecked = false));
        let myArray = ["Loan Application Form", "Sanction Letter", "Digital Process Note",
          "Digitally Signed Document", "CIC Report", "Charge Khasra PDF 1", "Charge Khasra PDF 3"];

        const reorderedPdfArray = myArray.map(label => this.downloadForms.find(item => item.label === label));
        console.log(reorderedPdfArray)
        // const filteredArray = reorderedPdfArray.find(item=>item!==undefined)
        this.downloadForms = reorderedPdfArray.filter(Boolean);
        console.log(this.downloadForms)
        this.openModal4(user);
      }
      else {
        this.loading = false;
        this.snackbar.open("No data found.", "OK", { duration: 3000 })
      }
      console.log(resp);
    }, (err) => {
      this.loading = false;
      this.snackbar.open("Something went wrong", "OK", { duration: 3000 })
    });
  }

  //Modal which comes after clicking download doc button
  openModal4(user: any) {
    // this.downloadDocModalRef = this.modalService.open(this.downloadModal);
    this.showDownloadDocsModal = true;
    console.log(user);
  }
  //Modal which comes after clicking download doc button

  closeDownloadDocModal() {
    // this.downloadDocModalRef.close();
    this.showDownloadDocsModal = !this.showDownloadDocsModal;
  }

  // selectAllDownloadForms(event: any) {
  //   if (event.target.checked) {
  //     this.downloadForms.forEach((form) => (form.isChecked = true));
  //     // this.checkRef.nativeElement.click();
  //     const checkbox = this.checkRef.nativeElement;
  //     checkbox.checked = !checkbox.checked;
  //     this.wantAccWiseBreDownloaded = true;
  //   } else {
  //     this.downloadForms.forEach((form) => (form.isChecked = false));
  //     // this.checkRef.nativeElement.click();
  //     const checkbox = this.checkRef.nativeElement;
  //     checkbox.checked = !checkbox.checked;
  //     this.wantAccWiseBreDownloaded = false;
  //   }
  // }
  

  // changeAccWiseBre(event: any) {
  //   if (event.target.checked) {
  //     this.wantAccWiseBreDownloaded = true
  //   } else {
  //     this.wantAccWiseBreDownloaded = false
  //   }
  // }

  get allDownloadFormsSelected(): boolean {
    const forms = this.downloadForms || [];
    return (
      forms.length > 0 &&
      forms.every((form) => form.isChecked) &&
      (!this.showAccwiseBreCheckBox || this.wantAccWiseBreDownloaded)
    );
  }

  selectAllDownloadForms(event: any) {
    const checked = event.target.checked;
    this.downloadForms.forEach((form) => (form.isChecked = checked));
    if (this.showAccwiseBreCheckBox) {
      this.wantAccWiseBreDownloaded = checked;
    }
  }

  changeAccWiseBre(event: any) {
    this.wantAccWiseBreDownloaded = event.target.checked;
  }

  downloadMyForms() {
    this.downloadForms.forEach((form) => {
      if (form.isChecked) {
        this.downloadLink(form);
      }
    });
    if (this.wantAccWiseBreDownloaded && this.isCoLogin()) {
      this.freshAuthService.downloadPdfAccWise(this.applicantId).subscribe(
        (resp) => {
        if (resp && resp.success) {
          if (resp.filePath) {

            try{
              const base64String = resp.filePath; // Your Base64 string here

              // Create a Blob from the Base64 string
              const byteCharacters = atob(base64String);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
  
              // Create a URL for the Blob
              const blobUrl = URL.createObjectURL(blob);
  
              // Create a link and trigger download
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = 'KCC-bre-checklist.pdf';// Filename when downloaded
              document.body.appendChild(link);
              link.click();
  
              // Clean up: Remove the link and revoke the Blob URL
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);
            }catch(err){
              this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
            }
            

          }else{
            this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
          }
        } else {
          this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
        }
      },(err)=>{
        this.snackbar.open("Accountwise BRE report download failed","OK",{duration:3000})
      })
    }
  }

  downloadLink(form: any) {
    // const { link, label } = form
    // const linkSource = link
    // const downloadLink = document.createElement("a");
    // const fileName = `${label}.pdf`;
    // console.log(label);

    // downloadLink.href = `${this.kccNewUat}/backend/${linkSource}`;
    // console.log(linkSource);

    // downloadLink.target = '_blank'
    // downloadLink.download = fileName;
    // console.log(fileName);

    // downloadLink.click();

    const { link, label } = form;
    const linkSource = link;
    const downloadLink = document.createElement('a');
    const fileName = `${label}.pdf`;
    console.log(label);

    downloadLink.href = `${this.kccNewUat}/static/${linkSource}`;
    console.log(linkSource);

    this.https.get(downloadLink.href, { responseType: 'arraybuffer' }).subscribe(
      (pdf) => {
        const blob = new Blob([pdf], { type: 'application/pdf' });
        const fileName = `${label}.pdf`;
        saveAs(blob, fileName);
      },
      (err) => {
        console.log('err->', err);
      }
    );
  }

  openErrorMessageDialog(content1: string, content2: string) {
    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      data: {
        content1: content1,
        content2: content2,
        button1Text: 'OK',
      },
    });
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateDisbursedStart');
    sessionStorage.removeItem('filterDateDisbursedEnd');
    sessionStorage.removeItem('filterDateDisbursed');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }
  ngOnDestroy() {
    console.log('foo destroy');
    sessionStorage.removeItem('filterDateDisbursedStart');
    sessionStorage.removeItem('filterDateDisbursedEnd');
  }

  isCoLogin() {
    if (this.roleId === '1') {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showDisbursedDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    try {
      this.freshAuthService.getDisbursed(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          this.allUsers = response && response.resultData ? response.resultData : [];
          if (!this.allUsers.length) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.allUsers = this.allUsers.sort(
              (a, b) => Number(new Date(b.loanCreationDate)) - Number(new Date(a.loanCreationDate))
            );
          }
          this.totalCount = response && response.count ? response.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = Math.ceil(this.totalCount / 10);
    }
  }
}
